__turbopack_context__.v({
  "quiz-page": "quiz-page-content-tabs-module-scss-module__QBJx3W__quiz-page",
  "quiz-page__button-icon": "quiz-page-content-tabs-module-scss-module__QBJx3W__quiz-page__button-icon",
  "quiz-page__description-container": "quiz-page-content-tabs-module-scss-module__QBJx3W__quiz-page__description-container",
  "quiz-page__text": "quiz-page-content-tabs-module-scss-module__QBJx3W__quiz-page__text",
  "quiz-tabs-list": "quiz-page-content-tabs-module-scss-module__QBJx3W__quiz-tabs-list",
  "topic-section": "quiz-page-content-tabs-module-scss-module__QBJx3W__topic-section",
  "topic-section-container": "quiz-page-content-tabs-module-scss-module__QBJx3W__topic-section-container",
  "topic-section-header": "quiz-page-content-tabs-module-scss-module__QBJx3W__topic-section-header",
  "topic-section-header__heading": "quiz-page-content-tabs-module-scss-module__QBJx3W__topic-section-header__heading",
  "topic-section-header__text": "quiz-page-content-tabs-module-scss-module__QBJx3W__topic-section-header__text",
});
